var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoticeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01493 3.68221C8.87195 2.10593 11.128 2.10593 11.9851 3.68221L17.2207 13.3119C18.0426 14.8236 16.952 16.6667 15.2356 16.6667H4.76436C3.048 16.6667 1.95741 14.8236 2.77929 13.3119L8.01493 3.68221Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 12.5C10.2284 12.5 10.4243 12.5807 10.5882 12.7422C10.752 12.9065 10.834 13.1042 10.834 13.3354C10.834 13.5637 10.752 13.7587 10.5882 13.9202C10.4243 14.0845 10.2284 14.1666 10.0007 14.1666C9.77565 14.1666 9.58121 14.0845 9.41732 13.9202C9.25065 13.7587 9.16732 13.5637 9.16732 13.3354C9.16732 13.1822 9.20621 13.0416 9.28399 12.9135C9.35899 12.7882 9.45899 12.6879 9.58399 12.6127C9.70899 12.5376 9.84787 12.5 10.0007 12.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6666L10 6.66663",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoticeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notice-icon.309a181a8d3dabe65b70eb8c42165bd9.svg";